// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4QVhG","container_video":"styles_container_video__viMXk","video":"styles_video__GaK9D","container_content":"styles_container_content__sM6pz"};